///<reference path="./smart-mover.models.ts"/>
///<reference path="filter-base.ts"/>


module Meevo.Components.Controls.SmartMover {


    import Dictionary = _.Dictionary;

    export abstract class CriteriaFilter extends FilterBase implements ICriteriaFilter {
        abstract readonly templateName: FilterTemplateNames;
        abstract readonly values: Dictionary<any>;
        abstract readonly criteria: Dictionary<any>;

        constructor(protected collections: IApiCollection<any>[], options: IDataTemplateFilterOptions = {}) {
            super(options);

            this.criteria = options.criteria || {};
            this.onFilterChange = _.debounce(this.onFilterChange.bind(this), 500);
        }

        onFilterChange() {
            this.updateCriteria();

            for (const collection of this.collections) {
                collection.updateCriteria(this.criteria);
                collection.fetch();
            }
        }

        abstract updateCriteria(): void;
    }
}
